import script from "./tabrButton.vue?vue&type=script&setup=true&lang=js"
export * from "./tabrButton.vue?vue&type=script&setup=true&lang=js"

import "./tabrButton.vue?vue&type=style&index=0&id=0549e1e2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0549e1e2"]])

export default __exports__